import axios from "axios";
import Config from "src/config";
import { authHeaders } from 'src/actions/authHeaders';

const v2_actionListaAgentesAi = (clienteId) => {
    return axios({
        headers: authHeaders(),
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/agentes/${clienteId}`
        });
};

export default v2_actionListaAgentesAi;
